import { Link } from 'react-router-dom';
import { useTranslation } from '../../../i18n/useTranslation';
import { routes } from '../../../Utils/routes';
import './Page404.css';

export function Page404() {
  const { tr } = useTranslation();
  return (
    <section className="not-found">
      <h1>{tr('errorNotFound')}</h1>
      <p>{tr('errorNotFoundHint')}</p>
      <Link to={routes.home}>{tr('back')}</Link>
    </section>
  );
}
